import * as Yup from 'yup';

export const validationSchema = Yup.object({
  eventDateTime: Yup.date()
    .typeError('Please enter a valid event date and time')
    .nullable()
    .required('Event date and time is required'),
  eventCategory: Yup.string().required('Event category is required'),
  phoneNumber: Yup.string().required('Home phone is a required field'),
  venueName: Yup.string().required('Venue name is required'),
  venueCity: Yup.string().required('Venue city is required'),
});

export const initialValues = {
  channel: '',
  subStatus: '',
  ticketProvider: '',
  deliveryType: '',
  cancellationReason: '',
  isEligibleForCashback: '',
  isLastCashbackBooking: '',
  isUseMailingAddress: true,
  phoneNumber: '',
  mobileNumber: '',
  alternatePhoneNumber: '',
  alternateEmail: '',
  comments: '',
  eventName: '',
  venueName: '',
  eventDateTime: null,
  eventCategory: '',
  bookingDate: null,
  seatDetails: '',
  bookingReference: '',
  postageFee: '',
  totalBookingFee: '',
  totalActualPrice: '',
  extraCashback: '',
  totalCashback: '',
  currency: '',
  totalPriceAfterDiscount: '',
  extraDiscountPercentage: '',
  buttonAction: '',
  deliveryName: '',
  addressLineOne: '',
  addressLineTwo: '',
  addressLineThree: '',
  city: '',
  postalCode: '',
  county: '',
  country: '',
  state: '',
  venueCity: '',
  otherVenueName: '',
};
